import CustomModal from '../../../../../../components/Modal/CustomModal';
import React from 'react';
import CustomizedItem from '../Components/CustomizedItem';
import { useTranslation } from 'react-i18next';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const CustomWorkShifts = (
    {
        show,
        onHide,
        list,
        setList,
        onDelete
    }
) => {
    const { t } = useTranslation();

    return (
        <CustomModal
            title={'custom_access'}
            show={show}
            onHide={() => {
                onHide();
            }}
            cancelButton={false}
            confirmButton={false}
            classNameBody="p-0 m-0"
        >
            <CustomizedItem
                t={t}
                title={''}
                list={list}
                setList={setList}
                showNoInformation={false}
                onDelete={onDelete}
            />
        </CustomModal>
    );
}

export default CustomWorkShifts

